import { StorageManager } from '@vben/utils'

export const localStorageManager = new StorageManager()

export const sessionStorageManager = new StorageManager({
  storageType: 'sessionStorage',
})
